import { RefObject, useEffect, useState } from 'react';
import { isNil } from 'lodash';

const useChildrenActive = (ref: RefObject<HTMLElement | null>) => {
  const [hasChildrenActive, setHasChildrenActive] = useState(false);

  // Observe changes in the children container to determine if it has active content
  useEffect(() => {
    const el = ref.current;

    if (isNil(el)) {
      return () => {};
    }

    const observer = new ResizeObserver(entries => {
      const entry = entries[0];

      if (entry) {
        setHasChildrenActive(entry.contentRect.height > 0);
      }
    });

    observer.observe(el);

    return () => observer.disconnect();
  }, [ref]);

  return hasChildrenActive;
};

export default useChildrenActive;
